<template>
  <div>
    <ion-page>
      <ion-header class="header-container">
        <ion-toolbar class="header-toolbar">
          <ion-buttons slot="start">
            <ion-back-button
              default-href="/home"
              color="light"
              text=""
            ></ion-back-button>
          </ion-buttons>
          <ion-title class="page-title">Wallet</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-row class="sm-row">
          <ion-col size="2" class="wallet-icon">
            <img src="assets/icon/google-connect.png" />
          </ion-col>
          <ion-col size="6">
            <span class="pm-label1">Google wallet</span>
            <span class="pm-label2">Username</span>
          </ion-col>
          <ion-col class="wc-icon position-right">
            <span class="wc-label1">Link wallet</span>
            <img src="assets/icon/link.png" />
          </ion-col>
        </ion-row>

        <ion-row class="sm-row">
          <ion-col size="2" class="wallet-icon">
            <img src="assets/icon/apple.png" />
          </ion-col>
          <ion-col size="6">
            <span class="pm-label1">Apple pay</span>
            <span class="pm-label2">Username</span>
          </ion-col>
          <ion-col class="wc-icon position-right">
            <span class="wc-label1">Link wallet</span>
            <img src="assets/icon/link.png" />
          </ion-col>
        </ion-row>
      </ion-content>
      <TheFooter name="TheFooter" />
    </ion-page>
  </div>
</template>
<style scoped>
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 64px;
}

.page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

.wallet-icon {
  margin-left: 3%;
}
.wc-icon {
  text-align: right;
  padding-top: 15px;
}
.wc-icon img {
  vertical-align: middle;
}
.sm-row {
  border-bottom: 1px solid #f3f3f3;
  padding-top: 10px;
  padding-bottom: 10px;
}
.position-right {
  position: absolute;
  right: 20px;
}

.pm-label1 {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
  padding-top: 5px;
}
.pm-label2 {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #828282;
  display: block;
}
.wc-label1 {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
  color: #f87e63;
  margin-right: 5px;
  margin-top: 10px;
}
</style>
<script>
import { defineComponent } from "vue";
import {
  IonContent,
  IonIcon,
  IonPage,
  IonRow,
  IonCol,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
} from "@ionic/vue";
import TheFooter from "@/components/TheFooter.vue";

export default defineComponent({
  name: "PaymentManagementPage",
  components: {
    IonContent,
    IonIcon,
    IonPage,
    IonRow,
    IonCol,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonBackButton,
    TheFooter,
  },
});
</script>
